import {UserForm } from "libs/raas-ui-react-components/src/components";
import useToast from "hooks/useToast";

export default function ContactComponent(/* props: any */) {
   /*  const { openToast } = useToast(); */
    // const sendForm = (data:any)=>{
    //     console.log("mandamos formulario", data.detail);
    //     openToast("success", "Formulario enviado", `Solicitud registrada correctamente`)
    // }
    return (
        <>
            <div className="container">
                <div className="col-xl-6 col-lg-8 col-md-12">
                    <UserForm /* onSendForm={sendForm} */></UserForm>
                </div>
            </div>
        </>

    )
}
